import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x-circle",
  "use": "icon-x-circle-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-x-circle\">\n<g id=\"icon-x-circle_x-circle\">\n<path id=\"icon-x-circle_Vector\" d=\"M8 5L4 9\" stroke=\"#98A1B3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path id=\"icon-x-circle_Vector_2\" d=\"M4 5L8 9\" stroke=\"#98A1B3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol